<template>
  <div>
    <Dialog
      :visible.sync="jobFunctionsForm1"
      :style="{ width: '640px', overflowY: 'auto' }"
      header="Job Function Details"
      :modal="true"
      class="p-fluid"
    >
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="jobFuncName">Name</label>
          <InputText
            id="jobFuncName"
            v-model.trim="jobFunction.jobFuncName"
            required="true"
            autofocus
            :class="{ 'p-invalid': submitted && !jobFunction.jobFuncName }"
            :disabled="disabledArr.includes('jobFuncName')"
          />
          <small class="p-invalid" v-if="submitted && !jobFunction.jobFuncName"
            >Name is required.</small
          >
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="jobFuncCode">Code</label>
          <InputText
            id="jobFuncCode"
            v-model.trim="jobFunction.jobFuncCode"
            required="true"
            autofocus
            :class="{ 'p-invalid': submitted && !jobFunction.jobFuncCode }"
            :disabled="disabledArr.includes('jobFuncCode')"
          />
          <small class="p-invalid" v-if="submitted && !jobFunction.jobFuncCode"
            >Code is required.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="active">Mark Active</label>
          <SelectButton
            v-model="jobFunction.active"
            :options="options"
            optionLabel="name"
          />
        </div>
      </div>

      <template #footer>
        <Button
          label="Reset"
          icon="pi pi-refresh"
          class="p-button-text"
          @click="reset"
        />
        <ProgressSpinner
          v-if="sendingRequest"
          style="width:25px; height:25px; width: 100px;"
          strokeWidth="5"
          fill="#EEEEEE"
          animationDuration=".5s"
        />
        <Button
          v-else
          label="Save"
          icon="pi pi-check"
          class="p-button-text"
          @click="save"
        />
        <Button
          label="Cancel"
          icon="pi pi-times"
          class="p-button-text"
          @click="cancel"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
export default {
  props: [
    "jobFunctionToEdit",
    "jobFunctionsForm",
    "sendingRequest",
    "disabledArr"
  ],
  data: () => ({
    jobFunction: {},
    submitted: false,
    options: [
      { name: "Active", value: true },
      { name: "Inactive", value: false }
    ]
  }),
  created() {
    if (this.jobFunctionToEdit && this.jobFunctionToEdit.id) {
      this.jobFunction = { ...this.jobFunctionToEdit };
      this.jobFunctionToEdit.active
        ? (this.jobFunction.active = { name: "Active", value: true })
        : (this.jobFunction.active = { name: "Inactive", value: false });
    }
  },
  computed: {
    jobFunctionsForm1: {
      set(val) {
        if (!val) {
          this.cancel();
        }
      },
      get() {
        return this.jobFunctionsForm ? true : false;
      }
    }
  },
  methods: {
    reset() {
      this.jobFunction = {};
    },
    save() {
      this.submitted = true;

      let obj = { ...this.jobFunction };

      if (obj.jobFuncName) {
        if (obj.active instanceof Object) {
          obj.active = obj.active.value;
        }

        this.$emit("save", obj);
      }
    },
    cancel() {
      this.$emit("close");
    }
  }
};
</script>

<style></style>
